// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Xa-Y","modalForm":"UpgradeEpcsModal_modalForm__3C3Ga","modalFooter":"UpgradeEpcsModal_modalFooter__3iXyS"};